import { Carousel } from "antd";

import "./Carrousel.scss";

export const Carrousel = () => {
  return (
    <Carousel autoplay className="c-carrousel">
      <div className="c-carrousel-frame">
        <div className="c-carrousel-frame__gradient">
          <div className="c-carrousel-frame__text-holder">
            <div className="c-carrousel-frame__text--title">
              Become a watizen to earn Pi
            </div>
            <div className="c-carrousel-frame__text--sub">
              Coming soon
            </div>
          </div>
        </div>
      </div>
      <div className="c-carrousel-frame">
        <div className="c-carrousel-frame__gradient">
          <div className="c-carrousel-frame__text-holder">
            <div className="c-carrousel-frame__text--title">
              Register your store today!
            </div>
            <div className="c-carrousel-frame__text--sub">
              Coming soon
            </div>
          </div>
        </div>
      </div>
    </Carousel>
  );
};
